import React from 'react';
import blog1 from '../../images/blogs/blog1.jpeg';
import blog2 from '../../images/blogs/blog2.jpeg';
import blog3 from '../../images/blogs/blog3.png';
import blog4 from '../../images/blogs/blog4.png';
import blog5 from '../../images/blogs/blog5.png';

import Navbar from '../Header/Navbar/Navbar';
import "./AllBlogs.css";
const AllBlogs = () => {
    return (
          <section>
              <Navbar></Navbar>
          
            <div className="container all-blogs">
            <div className="my-5">
            <div className="header text-center">
                    <h2>MY <span>BLOGS</span></h2>
                    <div className="wrapper">
                        <div className="divider div-transparent div-dot"></div>
                    </div>
                    </div>
                <div className="row my-5">
                    <div className="col-md-4 my-5">
                        <div class="card">
                            <img src={blog1} class="card-img-top card-shadow img-fluid" alt="..." />
                            <div style={{ backgroundColor: "#0a192f", color: "white" }} class="card-body">
                                <h4 class="card-title mb-3">10 Basic JavaScript Things</h4>
                               
                                <p class="card-text">JavaScript is Generally used for Developing Web Apps, Websites etc.
                         So I would Suggest to Learn HTML and CSS and know about these, Because these are also used for Web apps ,Web Designs and Websites etc....
                        
                        </p>
                        <a href="https://medium.com/@shohelranaBaig/10-basic-javascript-things-444bffa6f8f0" target="_blank" rel="noopener noreferrer">
                        <button style={{color: "black", fontWeight: "bold"}} className="btn btn-warning ">Read Details</button>
                        </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 my-5">
                        <div class="card">
                            <img src={blog2} class="card-img-top card-shadow img-fluid" alt="..." />
                            <div style={{ backgroundColor: "#0a192f", color: "white" }} class="card-body">
                                <h4 class="card-title">Most Important Topics In JavaScript</h4>
                                <p class="card-text">JavaScript is a Scripting or programming language of the Web.
                                JavaScript is used for Web apps, Websites etc. We can use it for spontaneous to debug and test...
                        
                        </p>
                        <br/>
                        <a href="https://shohelranabaig.medium.com/most-important-topics-in-javascript-936a88b25d42" target="_blank" rel="noopener noreferrer">
                        <button style={{color: "black", fontWeight: "bold"}} className="btn btn-warning">Read Details</button>
                        </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 my-5">
                        <div class="card">
                            <img src={blog3} class="card-img-top card-shadow img-fluid" alt="..." />
                            <div style={{ backgroundColor: "#0a192f", color: "white" }} class="card-body">
                                <h4 class="card-title">JavaScript Data Types, Error Handler, Function, ES6</h4>
                                <p class="card-text">1. JavaScript Data Types:
                                <br/>
                                There are 2 types of data types in JavaScript. They are -
                                <br/>
                                →Primitive Data Types. <br/>
                                →Non-primitive Data Types....  
                        </p>
                        <a href="https://shohelranabaig.medium.com/javascript-data-types-error-handler-function-es6-bfdf22b3f551" target="_blank" rel="noopener noreferrer">
                        <button style={{color: "black", fontWeight: "bold"}} className="btn btn-warning">Read Details</button>
                        </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 my-5">
                        <div class="card">
                            <img src={blog4} class="card-img-top card-shadow img-fluid" alt="..." />
                            <div style={{ backgroundColor: "#0a192f", color: "white" }} class="card-body">
                                <h4 class="card-title">Simple Introduction to <br/> R E A C T. J S</h4>
                                <p class="card-text">React is a JavaScript library for building user interfaces.
                                <br/>
                                1. React Create Element:
                                Call React.createElement( ) and describe its arguments.
                                Use ReactDOM.render( ) to render an element....
                        
                        </p>
                        <a href="https://shohelranabaig.medium.com/simple-introduction-to-r-e-a-c-t-j-s-9ccb9e2e4b15" target="_blank" rel="noopener noreferrer">
                        <button style={{color: "black", fontWeight: "bold"}} className="btn btn-warning">Read Details</button>
                        </a>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 my-5">
                        <div class="card">
                            <img src={blog5} class="card-img-top card-shadow img-fluid" alt="..." />
                            <div style={{ backgroundColor: "#0a192f", color: "white" }} class="card-body">
                                <h4 class="card-title">Advanced Guide In React & React Hooks</h4>
                                <p class="card-text">1. Closuers:
                                <br/>
                                Closures, the fundamental concept in JavaScript, are inner functions that have consent to the outer function variables and parameters....
                                <br/>
                        
                        </p>
                        <br/>
                        <a href="https://shohelranabaig.medium.com/advanced-guide-in-react-react-hooks-d51736547514" target="_blank" rel="noopener noreferrer">
                        <button style={{color: "black", fontWeight: "bold"}} className="btn btn-warning">Read Details</button>
                        </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </section>
    );
};

export default AllBlogs;